import { api } from '../axios';

const baseURL = '/GeneralOptions';

interface ICountries {
  id: string;
  value: string;
}
interface ICities {
  id: number;
  value: string;
}
interface IBranches {
  id: number;
  branchIdNumber: string;
  bankId: number;
  value: string;
}
interface IBanks {
  id: number;
  code: string;
  value: string;
  branches: IBranches[];
}
interface IGender {
  id: number;
  value: string;
}
interface IPhonePrefixes {
  id: number;
  value: string;
}
interface IMaritalStatuses {
  id: number;
  value: string;
}
interface IGeneral {
  genders: IGender[];
  phonePrefixes: IPhonePrefixes[];
  maritalStatuses: IMaritalStatuses[];
}

export interface IGeneralOptions {
  countries: ICountries[];
  cities: ICities[];
  banks: IBanks[];
  general: IGeneral;
}

export const getGeneralOptions = async (): Promise<
  IGeneralOptions | undefined
> => {
  const resCountries = await api.get<ICountries[]>(baseURL + '/Countries');
  const resCities = await api.get<ICities[]>(baseURL + '/Cities');
  const resBanks = await api.get<IBanks[]>(baseURL + '/Banks');
  const resGeneral = await api.get<IGeneral>(baseURL + '/General');

  return {
    countries: resCountries?.data,
    cities: resCities?.data,
    banks: resBanks?.data,
    general: resGeneral?.data,
  };
};
